const MIN_PROGRESS = 0;
const MAX_PROGRESS = 100;
export class ProgressPromise {
    constructor(executor) {
        this.listeners = [];
        this.progress = MIN_PROGRESS;
        this.done = (onFulfilled) => {
            return this.then(onFulfilled);
        };
        this.catch = (onRejected) => {
            return this.then(undefined, onRejected);
        };
        this.onProgress = (onProgress) => {
            return this.then(undefined, undefined, onProgress);
        };
        const report = (progress, details) => {
            if (progress <= MAX_PROGRESS && progress > this.progress) {
                this.progress = progress;
                this.listeners.forEach((listener) => listener(progress, details));
            }
        };
        this.promise = new Promise((resolve, reject) => {
            // @ts-ignore
            executor(resolve, reject, report);
        });
    }
    static resolve(value) {
        if (value instanceof ProgressPromise) {
            return value;
        }
        if (isPromiseLike(value)) {
            return new ProgressPromise((resolve, reject, reportProgress) => {
                // @ts-ignore
                value.then(resolve, reject, reportProgress);
            });
        }
        return new ProgressPromise(function (resolve, reject, reportProgress) {
            // @ts-ignore
            return Promise.resolve(value).then(resolve, reject, reportProgress);
        });
    }
    static all(promises = []) {
        const length = promises.length;
        if (length === 0) {
            // @ts-ignore
            return ProgressPromise.resolve([]);
        }
        const results = new Array(length);
        const progressBuffer = new Array(length).fill(MIN_PROGRESS);
        const progressDetailsBuffer = new Array(length).fill(undefined);
        let resolveCount = 0;
        return new ProgressPromise((resolve, reject, reportProgress) => {
            function notifyProgress(progress, progressDetails) {
                const sumProgress = progress.reduce((sum, subProgress) => sum + subProgress, 0);
                reportProgress(sumProgress / length, progressDetails);
            }
            promises.forEach((promise, index) => {
                ProgressPromise.resolve(promise).then((subResult) => {
                    results[index] = subResult;
                    progressBuffer[index] = MAX_PROGRESS;
                    resolveCount += 1;
                    notifyProgress(progressBuffer, progressDetailsBuffer);
                    if (resolveCount === length) {
                        resolve(results);
                    }
                    return subResult;
                }, (subError) => reject(subError), (subProgress, subProgressDetails) => {
                    progressBuffer[index] = clamp(subProgress, progressBuffer[index], MAX_PROGRESS);
                    progressDetailsBuffer[index] = subProgressDetails;
                    notifyProgress(progressBuffer, progressDetailsBuffer);
                });
            });
        });
    }
    then(onFulfilled, onRejected, onProgress) {
        return new ProgressPromise((resolve, reject, report) => {
            this.listeners.push(report);
            if (onProgress)
                this.listeners.push(onProgress);
            return this.promise.then(onFulfilled, onRejected).then(resolve, reject);
        });
    }
}
function isPromiseLike(value) {
    return value && typeof value.then === 'function';
}
function clamp(value, min, max) {
    if (value < min)
        return min;
    if (value > max)
        return max;
    return value;
}
//# sourceMappingURL=ProgressPromise.js.map